module.exports = __webpack_public_path__ + "static/media/coaching-color.25fe476b.svg";